import React from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Pick = ({ value, onChange, options, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-[160px] bg-white" data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>
      {options.map(([v, label]) => <SelectItem key={v} value={v} data-testid={`${testid}-${v}`}>{label}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const LeadsFilters = ({ f, set }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid="leads-filters">
    <Pick value={f.days} onChange={(v) => set({ days: v })} testid="filter-period"
      options={[["30", "30 derniers jours"], ["90", "90 derniers jours"], ["365", "12 derniers mois"], ["0", "Tout"]]} />
    <Pick value={f.status} onChange={(v) => set({ status: v })} testid="filter-status"
      options={[["all", "Tous les verdicts"], ["validated", "Validés"], ["unqualified", "Pas qualifiés"], ["pending", "En attente"]]} />
    <Pick value={f.type} onChange={(v) => set({ type: v })} testid="filter-type"
      options={[["all", "Formulaires et appels"], ["form", "Formulaires"], ["call", "Appels"]]} />
    <Input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Nom, téléphone, mot-clé…" className="w-[220px] bg-white" data-testid="filter-search" />
    <label className="flex items-center gap-2 text-sm text-slate-600">
      <Switch checked={f.tests} onCheckedChange={(v) => set({ tests: v })} data-testid="filter-show-tests" />
      Afficher les tests
    </label>
    {f.keyword !== null && (
      <button onClick={() => set({ keyword: null })} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-green-600 text-white text-sm" data-testid="filter-keyword-clear">
        Mot-clé : {f.keyword} <X className="w-3.5 h-3.5" />
      </button>
    )}
  </div>
);
